import { render, staticRenderFns } from "./ExhibitionInformation.vue?vue&type=template&id=137b56c1&"
import script from "./ExhibitionInformation.vue?vue&type=script&lang=js&"
export * from "./ExhibitionInformation.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionInformation.vue?vue&type=style&index=0&id=137b56c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports